import AboutUsView from "../views/AboutUsView";
import { observer } from "mobx-react-lite";

export default
observer(    
    function AboutUs(){
        return <AboutUsView/>;
    }
);